import { Action } from 'com/gongxigames/math/core/game/enums/Action';
import { ILogic } from '@gongxigames/framework/slot/types';
import { PromotionData, PromotionTypes, IPromotionLogic, IPromotionLogicInterface } from '@gongxigames/framework/promotions';

export class PromotionLogic<PromotionLogicInterface extends IPromotionLogicInterface = IPromotionLogicInterface>
    implements IPromotionLogic
{
    protected promotionInterface: PromotionLogicInterface;
    protected logic: ILogic;

    constructor(promotionInterfaceImpl: PromotionLogicInterface, logic: ILogic) {
        this.promotionInterface = promotionInterfaceImpl;
        this.logic = logic;
    }

    public get type(): PromotionTypes {
        return this.promotionInterface.getType();
    }

    public getData(): PromotionData {
        return {
            left: this.promotionInterface.getRemainedRounds(),
            total: this.promotionInterface.getTotalRounds(),
            id: this.promotionInterface.getID(),
            win: this.promotionInterface.getWin(),
            totalBet: this.promotionInterface.getBet() * this.logic.getWager(),
            totalPrice: this.logic.getPromotionPrice(this.promotionInterface.getQualifier(), this.promotionInterface.getBet()),
            type: this.promotionInterface.getQualifier(),
            isInUse: this.promotionInterface.isCurrentInUse(),
            started: this.promotionInterface.isCurrentInUse() && !this.promotionInterface.isActive(),
        };
    }

    public hasPromotion(): boolean {
        return this.promotionInterface.hasPromotion();
    }

    public isActive(): boolean {
        return this.promotionInterface.isActive();
    }

    public isExpired(): boolean {
        return this.promotionInterface.isCurrentExpired();
    }

    public shouldShowContinuePopup(): boolean {
        return this.promotionInterface.shouldShowContinuePopup?.() ?? false;
    }

    public isEndOfPromotion(): boolean {
        return this.isLastPromotion() && this.nextActionIsSpin;
    }

    public isLastPromotion(): boolean {
        return this.promotionInterface.getRemainedRounds() === 0;
    }

    public isNextPromotion(): boolean {
        return this.nextActionIsSpin && !this.isLastPromotion();
    }

    public subtractPromotion(): void {
        this.promotionInterface.subtractPromotion();
    }

    private get nextActionIsSpin(): boolean {
        return this.logic.nextAction === Action.SPIN;
    }
}
